import { HistoryTable } from '@/components/history/history-table';

export default function HistoryPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 w-full max-w-none flex-col gap-3 px-3 py-3">
      <h1 className="shrink-0 text-2xl font-bold">Histórico</h1>
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <HistoryTable />
      </div>
    </div>
  );
}
